module.exports = __webpack_public_path__ + "static/8-cc9a2cda8b8f948690f2fa3a84e57221.jpg";